"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AITeamPage = void 0;
const Leaf = __importStar(require("leaf-ts"));
const verset_business_1 = require("@project/verset_business");
const guildExplorer_1 = require("@branch-ts/practice-idps-web/src/guild/guildExplorer/guildExplorer");
const web_consensus_1 = require("@branch-ts/web-consensus");
const seqop_consensus_1 = require("@branch-ts/seqop-consensus");
const versetFacilityMechanism_1 = require("../versetFacilityMechanism");
const versetUserProfileMechanism_1 = require("../versetUserProfileMechanism");
const aiTeamPage_html_R_1 = require("./aiTeamPage.html.R");
const aiTeamPage_html_R_2 = require("./aiTeamPage.theme/business/aiTeamPage.html.R");
class AITeamPage extends aiTeamPage_html_R_1.R.AiTeamPage {
    constructor() {
        super(...arguments);
        this.stages = new web_consensus_1.StagesBehavior(this).defines({ access: "loading" });
        this.generation = 0;
        this.present = web_consensus_1.PresentMechanism.ensure(this).lifeCycle(async (about) => {
            await about.declare("present");
            const refresh = () => void this.refresh();
            versetUserProfileMechanism_1.VersetUserProfileMechanism.events.of.refresh.listenBy(this, refresh);
            window.addEventListener("focus", refresh);
            void this.refresh();
            await about.declare("hang");
            this.generation++;
            clearTimeout(this.expiryTimer);
            versetUserProfileMechanism_1.VersetUserProfileMechanism.events.stopListenBy(this);
            window.removeEventListener("focus", refresh);
            this.clearExplorer();
        });
    }
    async refresh() {
        const generation = ++this.generation;
        clearTimeout(this.expiryTimer);
        this.stages.set("access", "loading");
        try {
            const [result, reason] = await versetFacilityMechanism_1.VersetFacilityMechanism.ensureServer().rpcs.VersetUserSubscriptionService.getMySubscription({});
            if (generation !== this.generation)
                return;
            if (reason || !result) {
                this.clearExplorer();
                this.stages.set("access", "error");
                return;
            }
            if (!(0, verset_business_1.hasVersetPaidAIAccess)(result.subscription)) {
                this.clearExplorer();
                this.stages.set("access", "locked");
                return;
            }
            this.expiryTimer = setTimeout(() => {
                // Browser timers cap at ~24 days; longer paid cycles need a
                // fresh check at that cap, not an early downgrade.
                if (Date.now() < result.subscription.prevail.end) {
                    void this.refresh();
                    return;
                }
                this.generation++;
                this.clearExplorer();
                this.stages.set("access", "locked");
            }, Math.min(result.subscription.prevail.end - Date.now(), 2_147_483_647));
            if (!this.explorer) {
                const guild = versetFacilityMechanism_1.VersetFacilityMechanism.ensureApp().getServiceByName("VersetGuildService");
                const uri = await guild.getOrCreateMyGuildURI();
                if (generation !== this.generation)
                    return;
                const mediator = seqop_consensus_1.MediatorRegistryMechanism.ensure({ uri });
                const [, mediatorReason, ...mediatorErrors] = await mediator.wait();
                if (mediatorReason)
                    throw new Error([mediatorReason, ...mediatorErrors.map(error => error.message)].join(" "));
                if (generation !== this.generation)
                    return;
                const explorer = new guildExplorer_1.GuildExplorer();
                this.explorer = explorer;
                this.UI.content.appendChild(explorer.node);
                await explorer.present.configure({ guildMediator: mediator, uri, editorKind: guild.editorKind });
                await explorer.situations.wait("ready", true);
                if (generation !== this.generation)
                    return;
            }
            if (generation === this.generation)
                this.stages.set("access", "team");
        }
        catch {
            if (generation !== this.generation)
                return;
            clearTimeout(this.expiryTimer);
            this.clearExplorer();
            this.stages.set("access", "error");
        }
    }
    clearExplorer() {
        this.explorer?.present.dismiss();
        this.explorer?.node.remove();
        this.explorer = undefined;
    }
    onClickSubscribe(e) {
        e?.preventDefault();
        e?.stopPropagation();
        versetFacilityMechanism_1.VersetFacilityMechanism.ensureApp().getServiceByName("VersetBillingService").showSubscriptionGate();
    }
    onClickRetry(e) {
        e?.preventDefault();
        e?.stopPropagation();
        void this.refresh();
    }
}
exports.AITeamPage = AITeamPage;
Leaf.WidgetThemeCenter.about(aiTeamPage_html_R_1.R.AiTeamPage).add("business", aiTeamPage_html_R_2.R.AiTeamPage.generator);
